"use client";

import createIcon from './util/createIcon';
export default createIcon('M19.78,11.78L18.36,13.19L12,6.83L5.64,13.19L4.22,11.78L12,4L19.78,11.78Z', 'AppleKeyboardControl');